const key = 'HSYLC_2021_WELCOME_READED';
export default class {
  constructor() {
    this.key = key;
    this.readed = !!localStorage.getItem(this.key);
  }
  setRead() {
    localStorage.setItem(this.key, '1');
  }
}
